import { render, staticRenderFns } from "./EditViewTermReportsSubjectRow.vue?vue&type=template&id=0f2601c4&scoped=true"
import script from "./EditViewTermReportsSubjectRow.vue?vue&type=script&lang=js"
export * from "./EditViewTermReportsSubjectRow.vue?vue&type=script&lang=js"
import style0 from "./EditViewTermReportsSubjectRow.vue?vue&type=style&index=0&id=0f2601c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2601c4",
  null
  
)

export default component.exports